import LocationHours from '../components/LocationHours.vue';
import Vue from 'vue';

export default {
  init() {
    let app = new Vue(LocationHours);

    app.$mount('#location-hours');
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/single-location.js